"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardDeeplink = exports.standardUniversalLink = exports.tonConnectSdkVersion = void 0;
exports.tonConnectSdkVersion = '1';
exports.standardUniversalLink = 'https://www.okx.com/download';
exports.standardDeeplink = 'okx://web3/wallet/connect';
